import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  heroTitle: {
    id: 'catalog.home.jiltarjih.hero.title',
    defaultMessage: 'أكاديمية جيل الترجيح',
    description: 'Main title displayed in the Jil Tarjih homepage hero.',
  },
  heroLead: {
    id: 'catalog.home.jiltarjih.hero.lead',
    defaultMessage: 'منصة تعليمية تجمع بين المساقات المعرفية والتأهيل التربوي والمهارات القيادية في تجربة واحدة.',
    description: 'Lead paragraph displayed in the Jil Tarjih homepage hero.',
  },
  heroSearchPlaceholder: {
    id: 'catalog.home.jiltarjih.hero.searchPlaceholder',
    defaultMessage: 'ماذا تريد أن تتعلم اليوم؟',
    description: 'Placeholder text inside the hero course search field.',
  },
  heroVideoCta: {
    id: 'catalog.home.jiltarjih.hero.videoCta',
    defaultMessage: 'شاهد الفيديو التعريفي',
    description: 'Label for the hero promo video trigger.',
  },
  stepsEyebrow: {
    id: 'catalog.home.jiltarjih.steps.eyebrow',
    defaultMessage: 'كيف أبدأ التعلم؟',
    description: 'Eyebrow for the learning steps section.',
  },
  stepsTitle: {
    id: 'catalog.home.jiltarjih.steps.title',
    defaultMessage: 'ابدأ رحلتك بخطوات واضحة ومباشرة',
    description: 'Title for the learning steps section.',
  },
  stepChooseTitle: {
    id: 'catalog.home.jiltarjih.steps.choose.title',
    defaultMessage: 'اختر المساقات التي تريد',
    description: 'Title for the first learning step.',
  },
  stepChooseText: {
    id: 'catalog.home.jiltarjih.steps.choose.text',
    defaultMessage: 'لك حرية اختيار المساقات التي تناسبك، سواء أكنت طالبا أو محترفا أو في بداية مسيرتك المهنية',
    description: 'Description for the first learning step.',
  },
  stepPaceTitle: {
    id: 'catalog.home.jiltarjih.steps.pace.title',
    defaultMessage: 'تعلم بالوتيرة التي تناسبك',
    description: 'Title for the second learning step.',
  },
  stepPaceText: {
    id: 'catalog.home.jiltarjih.steps.pace.text',
    defaultMessage: 'يمكنك متابعة المساقات في أي وقت و من أي مكان، سواء من الحاسوب أو من هاتفك الذكي',
    description: 'Description for the second learning step.',
  },
  stepCertificateTitle: {
    id: 'catalog.home.jiltarjih.steps.certificate.title',
    defaultMessage: 'احصل على الشهادة',
    description: 'Title for the third learning step.',
  },
  stepCertificateText: {
    id: 'catalog.home.jiltarjih.steps.certificate.text',
    defaultMessage: 'بعد إتمامك للمساق يمكنك الحصول على شهادة معتمدة ستكون إضافة قيمة إلى سيرتك',
    description: 'Description for the third learning step.',
  },
  coursesEyebrow: {
    id: 'catalog.home.jiltarjih.courses.eyebrow',
    defaultMessage: 'أحدث المساقات',
    description: 'Eyebrow for the recent courses section.',
  },
  coursesTitle: {
    id: 'catalog.home.jiltarjih.courses.title',
    defaultMessage: 'أحدث الفرص التعليمية',
    description: 'Title for the recent courses section.',
  },
  coursesCta: {
    id: 'catalog.home.jiltarjih.courses.cta',
    defaultMessage: 'عرض جميع المساقات',
    description: 'Call to action for the recent courses section.',
  },
  servicesEyebrow: {
    id: 'catalog.home.jiltarjih.services.eyebrow',
    defaultMessage: 'خدماتنا',
    description: 'Eyebrow for the services section.',
  },
  servicesTitle: {
    id: 'catalog.home.jiltarjih.services.title',
    defaultMessage: 'مسارات متكاملة لبناء المعرفة والقيادة',
    description: 'Title for the services section.',
  },
  serviceKnowledgeTitle: {
    id: 'catalog.home.jiltarjih.services.knowledge.title',
    defaultMessage: 'المساقات المعرفية',
    description: 'Title for the knowledge services card.',
  },
  serviceKnowledgeText: {
    id: 'catalog.home.jiltarjih.services.knowledge.text',
    defaultMessage: 'تقدم أكاديمية جيل الترجيح مجموعة من المساقات المعرفية، ومداخل علوم ومقاييس قيادية تهدف من خلالها إلى إكساب المتعلمين أهم النظريات والعلوم التي يجب على الساعي إلى القيادة أن يتعلمها. وتتبع الأكاديمية منهجية المقاربة بالكفايات لتحقيق أكبر قدر من الفائدة من المواد المقررة عبر تطبيق ما جاء فيها على الإشكاليات التي تواجه الطالب في الحياة.',
    description: 'Description for the knowledge services card.',
  },
  serviceEducationTitle: {
    id: 'catalog.home.jiltarjih.services.education.title',
    defaultMessage: 'الدورات التربوية',
    description: 'Title for the educational services card.',
  },
  serviceEducationText: {
    id: 'catalog.home.jiltarjih.services.education.text',
    defaultMessage: 'تمثل تزكية النفس أحد أهم الركائز التي يقوم عليها برنامج الأكاديمية في شقه السلوكي. وانطلاقا من هذه المركزية، صممت الأكاديمية منظومة متكاملة لبناء القيم وتعديل سلوك الأفراد تتمثل في: الدورات التربوية الشهرية، الدورات الروحية الفصلية، مخيمات الحفظ المكثف والملتقيات الوطنية المتخصصة في هذا الجانب.',
    description: 'Description for the educational services card.',
  },
  serviceTrainingTitle: {
    id: 'catalog.home.jiltarjih.services.training.title',
    defaultMessage: 'الدورات التدريبية',
    description: 'Title for the training services card.',
  },
  serviceTrainingText: {
    id: 'catalog.home.jiltarjih.services.training.text',
    defaultMessage: 'يتدرب الفرد في أكاديمية جيل الترجيح على عدد من المهارات الأساسية التي يجب أن يتمكن منها القائد عبر منظومة متكاملة منهجيتها كالآتي: مهارات بناء الذات، مهارات إدارية وقيادية، مهارات تلبي الاحتياج الوظيفي (بعد اختيار التخصص) مع برنامج لمرافقة الفرد ليتمكن من تطبيق هذه المهارات وصقلها بعد الدورات.',
    description: 'Description for the training services card.',
  },
  serviceProjectsTitle: {
    id: 'catalog.home.jiltarjih.services.projects.title',
    defaultMessage: 'الحملات و المشاريع',
    description: 'Title for the campaigns and projects services card.',
  },
  serviceProjectsText: {
    id: 'catalog.home.jiltarjih.services.projects.text',
    defaultMessage: 'تسعى أكاديمية جيل الترجيح إلى تدريب الفرد على القيادة الميدانية، عبر تنظيم عدد من الحملات المتنوعة التي تتيح له تطبيق كل من النظريات واستعمال المهارات التي اكتسبها من برنامج الأكاديمية. كما تتبنى المشاريع المبدعة التي تؤسس من طرف القادة، وتدعمها بمختلف الوسائل لتنضج إلى مؤسسات قائمة بذاتها تساهم في نفع الأمة وتحقيق رؤية الأكاديمية.',
    description: 'Description for the campaigns and projects services card.',
  },
  partnersEyebrow: {
    id: 'catalog.home.jiltarjih.partners.eyebrow',
    defaultMessage: 'شركاؤنا',
    description: 'Eyebrow for the partners section.',
  },
  partnersTitle: {
    id: 'catalog.home.jiltarjih.partners.title',
    defaultMessage: 'شبكة من المؤسسات الداعمة والملهمة',
    description: 'Title for the partners section.',
  },
  partnerLta: {
    id: 'catalog.home.jiltarjih.partners.lta',
    defaultMessage: 'أكاديمية إعداد القادة',
    description: 'Name of the Leaders Preparation Academy partner.',
  },
  partnerNbquran: {
    id: 'catalog.home.jiltarjih.partners.nbquran',
    defaultMessage: 'النهضة بالقرآن',
    description: 'Name of the Quran Revival partner.',
  },
  partnerAlmaali: {
    id: 'catalog.home.jiltarjih.partners.almaali',
    defaultMessage: 'جمعية المعالي للعلوم والتربية',
    description: 'Name of the Al Maali partner.',
  },
  partnerRoshd: {
    id: 'catalog.home.jiltarjih.partners.roshd',
    defaultMessage: 'جمعية رشد للتأهيل والنشاط الشبابي',
    description: 'Name of the Roshd partner.',
  },
  partnerElbassira: {
    id: 'catalog.home.jiltarjih.partners.elbassira',
    defaultMessage: 'مركز البصيرة',
    description: 'Name of the Elbassira partner.',
  },
  partnerLictc: {
    id: 'catalog.home.jiltarjih.partners.lictc',
    defaultMessage: 'مركز تعلم الدولي',
    description: 'Name of the LICTC partner.',
  },
  partnerKlForum: {
    id: 'catalog.home.jiltarjih.partners.klforum',
    defaultMessage: 'منتدى كوالالمبور',
    description: 'Name of the Kuala Lumpur Forum partner.',
  },
  partnerThuraya: {
    id: 'catalog.home.jiltarjih.partners.thuraya',
    defaultMessage: 'شركة الثريا',
    description: 'Name of the Thuraya partner.',
  },
  testimonialsEyebrow: {
    id: 'catalog.home.jiltarjih.testimonials.eyebrow',
    defaultMessage: 'يقولون عنا',
    description: 'Eyebrow for the testimonials section.',
  },
  testimonialsTitle: {
    id: 'catalog.home.jiltarjih.testimonials.title',
    defaultMessage: 'شهادات تعكس أثر التجربة',
    description: 'Title for the testimonials section.',
  },
  testimonialsPrev: {
    id: 'catalog.home.jiltarjih.testimonials.previous',
    defaultMessage: 'الشهادة السابقة',
    description: 'Accessible label for the previous testimonial button.',
  },
  testimonialsNext: {
    id: 'catalog.home.jiltarjih.testimonials.next',
    defaultMessage: 'الشهادة التالية',
    description: 'Accessible label for the next testimonial button.',
  },
  testimonialTareqName: {
    id: 'catalog.home.jiltarjih.testimonials.tareq.name',
    defaultMessage: 'د.طارق السويدان',
    description: 'Name of the first testimonial author.',
  },
  testimonialTareqRole: {
    id: 'catalog.home.jiltarjih.testimonials.tareq.role',
    defaultMessage: 'مدرب وخبير إدارة عالمي',
    description: 'Role of the first testimonial author.',
  },
  testimonialTareqText: {
    id: 'catalog.home.jiltarjih.testimonials.tareq.text',
    defaultMessage: 'أكاديمية جيل الترجيح للتأهيل القيادي هي من الأكاديميات الناجحة جدا ونموذج رائع لإعداد القادة بجهد شبابي خالص',
    description: 'Quote of the first testimonial author.',
  },
  testimonialNawfalName: {
    id: 'catalog.home.jiltarjih.testimonials.nawfal.name',
    defaultMessage: 'د. أحمد نوفل',
    description: 'Name of the second testimonial author.',
  },
  testimonialNawfalRole: {
    id: 'catalog.home.jiltarjih.testimonials.nawfal.role',
    defaultMessage: 'أكاديمي وداعية',
    description: 'Role of the second testimonial author.',
  },
  testimonialNawfalText: {
    id: 'catalog.home.jiltarjih.testimonials.nawfal.text',
    defaultMessage: 'هذا المشروع رائد ومشروع عظيم....ما أنتم فيه أسوة لإخوانكم في المشرق، وسننقل تجربتكم من المغرب إلى المشرق، إن شاء الله تعالى، لأنكم أنتم أصبحتم بهذا الجهد مدرسة وطليعة لإخوانكم المسلمين في كل مكان',
    description: 'Quote of the second testimonial author.',
  },
  testimonialGhadbanName: {
    id: 'catalog.home.jiltarjih.testimonials.ghadban.name',
    defaultMessage: 'د.منير غضبان (رحمه الله)',
    description: 'Name of the third testimonial author.',
  },
  testimonialGhadbanRole: {
    id: 'catalog.home.jiltarjih.testimonials.ghadban.role',
    defaultMessage: 'داعية إسلامي',
    description: 'Role of the third testimonial author.',
  },
  testimonialGhadbanText: {
    id: 'catalog.home.jiltarjih.testimonials.ghadban.text',
    defaultMessage: 'حينما سمعت للوهلة الأولى عبارة "جيل الترجيح" لم تعجبني العبارة ولكن حينما تذكرت الحديث الصحيح علمت بأن اختيار اسم جيل الترجيح فيه توفيق من الله',
    description: 'Quote of the third testimonial author.',
  },
  testimonialBoussagName: {
    id: 'catalog.home.jiltarjih.testimonials.boussag.name',
    defaultMessage: 'د. أحمد بوساق',
    description: 'Name of the fourth testimonial author.',
  },
  testimonialBoussagRole: {
    id: 'catalog.home.jiltarjih.testimonials.boussag.role',
    defaultMessage: 'علاَّمة جزائري',
    description: 'Role of the fourth testimonial author.',
  },
  testimonialBoussagText: {
    id: 'catalog.home.jiltarjih.testimonials.boussag.text',
    defaultMessage: 'إن مصير الدعوة هو بأيديهم (أي جيل الترجيح) فنجاحهم في هذا المشروع هو استنهاض لجميع همم المسلمين في كل أنحاء العالم، وإعطاؤهم الثقة والأمل في حصول التغيير المنشود، وأي فشل فإنه سيؤدي إلى الإحباط وترك المحاولات، ولذلك فإننا نعد هذا المشروع أمانة في أعناقهم وينبغي أن يبذلوا وسعهم ويستفرغوا جهدهم، بلا كلل ولا ملل، وأن يحتسبوا أعمالهم لله تعالى، لإنجاز أفضل وأعظم مشروع تم التخطيط وبناؤه على أسس علمية ومنطلقات شرعية',
    description: 'Quote of the fourth testimonial author.',
  },
});

export default messages;
